import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, postData } from "src/utils/axios/serverHelper";

import {
	TQC2011_R01Dto,
	TQC2011_R01HeaderDto,
} from "./Dto_TQC2011_R01";

const baseUrl = `${config.apiUrl}/TQC2011_R01`;

export interface TQC2011_R01Params {
	compCd?: string;
	startDate?: string;
	endDate?: string;
	workplaceCd?: string;
	itemCd?: string;
	productEmp?: string;
}

export interface TQC2011_R01DetailParams {
	productResultNo: string;
	inspectType: string;
}

export const getTQC2011_R01List = async (
	option: string,
	params: TQC2011_R01Params,
) => getData<ResponseDto<TQC2011_R01HeaderDto[]>>(`${baseUrl}/${option}`, { params });

export const getTQC2011_R01AllCount = async (params: TQC2011_R01Params) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params });

export const getTQC2011_R01Detail = async (params: TQC2011_R01DetailParams) =>
	getData<ResponseDto<TQC2011_R01Dto>>(`${baseUrl}/detail`, { params });

export const saveTQC2011_R01 = async (payload: TQC2011_R01Dto) =>
	postData<TQC2011_R01Dto, ResponseDto<number>>(`${baseUrl}/save`, payload);

export const deleteTQC2011_R01 = async (header: TQC2011_R01HeaderDto) =>
	postData<TQC2011_R01HeaderDto, ResponseDto<number>>(`${baseUrl}/delete`, header);

export const downloadExcel_TQC2011_R01 = async (params: TQC2011_R01Params) =>
	getData<ResponseDto<string>>(`${baseUrl}/excel`, { params });

export const downloadCertificatePdf_TQC2011_R01 = async (
	params: TQC2011_R01DetailParams,
) =>
	getData<Blob>(`${baseUrl}/report/certificate`, {
		params,
		responseType: "blob",
		headers: { Accept: "application/pdf" },
	});
